"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorShippingOption = void 0;
const core_1 = require("@material-ui/core");
const select_1 = require("client/components/material/select");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const styles = core_1.createStyles({
    root: {
        margin: "1rem 0"
    },
    distributor: {}
});
const decorate = core_1.withStyles(styles);
let DistributorShippingOptionUnstyled = class DistributorShippingOptionUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.shippingMethods = new Map();
        this.initializeShippingMethods = (props) => {
            this.shippingMethods.clear();
            const { distributors } = props;
            for (const distributor of distributors) {
                const { id } = distributor;
                if (!this.shippingMethods.has(id)) {
                    this.shippingMethods.set(id, distributor);
                }
            }
            this.handleShippingOptionsChange();
        };
        this.handleShippingOptionsChange = () => {
            const shippingMethods = Array.from(this.shippingMethods.values()).map(method => {
                return {
                    id: method.id,
                    distributor: method.distributor,
                    method: method.shippingMethod
                };
            });
            this.props.onShippingOptionsChange(shippingMethods);
        };
        this.handleOnSelect = (distributor) => (value) => {
            const updated = this.shippingMethods.get(distributor.id);
            updated.shippingMethod = value;
            this.shippingMethods.set(distributor.id, updated);
            this.handleShippingOptionsChange();
        };
        this.getAvailableOptions = (distributor) => {
            const { shippingOptions } = distributor;
            return shippingOptions
                ? shippingOptions.map((option, index) => ({
                    id: index,
                    label: option.method,
                    value: option.method
                }))
                : [];
        };
    }
    componentWillReceiveProps(props) {
        this.initializeShippingMethods(props);
    }
    render() {
        const { classes, distributors } = this.props;
        return (React.createElement("div", { className: classes.root },
            React.createElement(core_1.Typography, { variant: "title", gutterBottom: true }, "Distributors Shipping Options"),
            distributors.map((distributor, index) => {
                const { distributor: distributorName } = distributor;
                return (React.createElement("div", { key: index, className: classes.distributor },
                    React.createElement(core_1.Typography, { variant: "title", gutterBottom: true }, distributorName),
                    React.createElement(select_1.MaterialSelect, { className: "edit-order-header__select-site", options: distributor ? this.getAvailableOptions(distributor) : [], required: true, searchable: true, label: "Shipping Method", onSelect: this.handleOnSelect(distributor), value: this.shippingMethods.has(distributor.id)
                            ? this.shippingMethods.get(distributor.id).shippingMethod
                            : "" })));
            })));
    }
};
__decorate([
    mobx_1.observable
], DistributorShippingOptionUnstyled.prototype, "shippingMethods", void 0);
DistributorShippingOptionUnstyled = __decorate([
    mobx_react_1.observer
], DistributorShippingOptionUnstyled);
exports.DistributorShippingOption = decorate(DistributorShippingOptionUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/quick-order/components/distributor-shipping-option/distributor-shipping-option.tsx
// module id = 3603
// module chunks = 0